<template>
  <div class="catalog-form" style="position: relative; display: flex; flex-direction: column;">
    <h1 id="init">
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>
    </h1>

    <b-row class="workspace-actions">
      <b-col>
        <template v-for="action in getActions">
          <b-button
            v-if="action.display"
            :key="action.name"
            class="workspace-action"
            variant="light"
            @click="action.onClick"
            :disabled="action.disabled">
              <i :class="action.icon"></i>&nbsp;{{ action.name }}
          </b-button>
        </template>
      </b-col>
    </b-row>

    <div class="form-area full-width" :class="{ collapsed: formOpen }">
      <b-card class="form-section" v-if="id">
        <table class="table table-responsive-xl table-hover table-bordered workspaces-table" style="margin: 0" v-if="workspaces.length">
          <thead>
            <tr>
              <!--th scope="col">Dueño</th-->
              <th scope="col">Dominio</th>
              <th scope="col">Estado (Workspace)</th>
              <th scope="col" v-if="!formOpen">Día de facturación</th>
              <th scope="col" v-if="!formOpen">Día consolidado en factura</th>
              <th scope="col" v-if="!formOpen">Contacto</th>
              <th scope="col" v-if="!formOpen">Teléfono</th>
              <th scope="col" v-if="!formOpen">Correo electrónico</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="it in workspaces" :key="it.id" @click="workspaceSelected = formOpen ? workspaceSelected : it" :class="{ selected:  workspaceSelected === it }">
              <td style="width: 15px"><i class="fas fa-user-shield" v-if="it.owner"></i></td>
              <td style="max-width: 200px">{{ it.domain.name }}</td>
              <td>{{ getWorkspaceStatusDescription(it.status) }}</td>
              <td style="width: 150px" v-if="!formOpen">{{ it.facturationDate }}</td>
              <td style="width: 210px" v-if="!formOpen">{{ it.consolidatedInvoice ? 'Sí' : 'No' }}</td>
              <td v-if="!formOpen">{{ it.contact.name }}</td>
              <td v-if="!formOpen">{{ it.contact.contactTelephone }}</td>
              <td v-if="!formOpen">{{ it.contact.contactEmail }}</td>
            </tr>
          </tbody>
        </table>

        <div class="no-data" v-else>
          <h5 style="opacity: 0.4; margin: 0;">No existen dominios relacionados a este cliente</h5>
        </div>
      </b-card>
    </div>

    <!-- FORMULARIO ALTA/MODIFICACION DE WORKSPACE -->
    <div class="workspace-form-modal animate__animated animate__fadeInRight animate__faster" v-if="formOpen">
      <h5>Datos de relación Cliente - Dominio</h5>
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group
          id="input-group-domain"
          label="Dominio *"
          label-for="input-domain"
          style="position: relative">
          <b-form-input
            id="input-domain"
            name="input-domain"
            type="text"
            class="shadow-none"
            placeholder="Seleccione el dominio"
            v-model.trim="searchDomain"
            :maxlength="255"
            autocomplete="off"
            @click="showDomainSelection(true)"
            @focus="showDomainSelection(true)"
            @blur="showDomainSelection(false)"
            :disabled="!!workspaceSelected.id">
          </b-form-input>
          <div class="dropdown-input-selection-list" v-if="domainSelectionOpen">
            <table class="table">
              <tbody>
                <tr v-for="it in domains" :key="it.id" @click="selectDomain(it)" v-show="isMatchDomain(it)">
                  <td>{{ it.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <small v-show="domainSelected.id && domainSelectedWorkspaces.total === 0" class="text-info">
            Este será el primer workspace para el dominio seleccionado, por lo cual, este sería marcado como <span class="font-weight-bold">owner</span> automáticamente.
          </small>
        </b-form-group>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <b-form-group id="input-group-status" label="Estado">
              <b-form-select
                id="input-select-status"
                name="input-select-status"
                class="shadow-none"
                v-model="form.status"
                :options="workspacesStatus"
                :disabled="true">
              </b-form-select>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-6">
            <b-form-group id="input-group-facturation-date" label="Día de facturación">
              <b-form-select
                id="input-select-facturation-date"
                name="input-select-facturation-date"
                class="shadow-none"
                v-model="form.facturationDate"
                :options="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]">
              </b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <b-form-group
              id="input-group-contact-name"
              label="Contacto *"
              label-for="input-contact-name">
              <b-form-input
                id="input-contact-name"
                name="input-contact-name"
                type="text"
                class="shadow-none"
                placeholder="Nombre del contacto"
                v-model.trim="form.contact.name"
                :maxlength="255"
                v-validate="{ required: true }"
                :state="validateState('input-contact-name')"
                aria-describedby="input-contact-name-feedback"
                :disabled="readOnly">
              </b-form-input>
              <b-form-invalid-feedback id="input-contact-name-feedback">El nombre del contacto es requerido</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-6">
            <b-form-group
              id="input-group-email"
              label="Correo electrónico *"
              label-for="input-email">
              <b-form-input
                id="input-email"
                name="input-email"
                type="email"
                class="shadow-none"
                placeholder="Correo electrónico"
                v-model.trim="form.contact.contactEmail"
                :maxlength="255"
                v-validate="{ required: true, email: true  }"
                :state="validateState('input-email')"
                aria-describedby="input-email-feedback"
                :disabled="readOnly">
              </b-form-input>
              <b-form-invalid-feedback id="input-email-feedback">Introduzca un correo válido</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-6">
            <b-form-group
              id="input-group-phone"
              label="Teléfono *"
              label-for="input-phone">
              <b-form-input
                id="input-phone"
                name="input-phone"
                type="text"
                class="shadow-none"
                placeholder="Ej. 5537081925, +525537081925"
                v-model.trim="form.contact.contactTelephone"
                :maxlength="16"
                v-validate="{ required: true, regex: regexPhone  }"
                :state="validateState('input-phone')"
                aria-describedby="input-phone-feedback"
                :disabled="readOnly">
              </b-form-input>
              <b-form-invalid-feedback id="input-phone-feedback">Introduzca un teléfono válido</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>

        <b-form-group>
          <b-form-checkbox v-model="form.consolidatedInvoice">Detalle consolidado en factura</b-form-checkbox>
        </b-form-group>

        <!-- ACCIONES -->
        <div class="text-right" v-show="!loading">
          <b-button class="mr-2" @click="showForm(false)">Cancelar</b-button>
          <b-button type="submit" variant="primary" v-if="!readOnly">Guardar</b-button>
        </div>
      </b-form>
    </div>

    <!--GENERACION DE REPORTE-->
    <b-modal
        id="report-support-billing"
        scrollable
        header-bg-variant="light"
        header-text-variant="dark"
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close>
        <div>
          <label>Tipo de reporte:</label>
          <b-form-select v-model="detailReport">
            <b-form-select-option disabled hidden :value=-1>Seleccione el reporte a generar</b-form-select-option>
            <b-form-select-option :value=1>Consolidado (listado de licencias)</b-form-select-option>
            <b-form-select-option :value=2>Detallado (consumo por licencia)</b-form-select-option>
          </b-form-select>
        </div>
        <div>
          <label>Periodo del reporte:</label>
          <b-form-select v-model="monthReport">
            <b-form-select-option disabled hidden :value=-1>Seleccione el mes a generar</b-form-select-option>
            <b-form-select-option :value=1>{{previousMonthName()}}</b-form-select-option>
            <b-form-select-option :value=2>{{currentMonthName()}}</b-form-select-option>
          </b-form-select>
        </div>
        <div class="mt-2">
          <span>El reporte se enviara al correo: {{userEmail}}</span>
        </div>
        <template v-slot:modal-title>
          <div class="inline">
            <i class="far fa-file-invoice-dollar"></i>
            Detalle de facturación mensual
          </div>
        </template>
        <template v-slot:modal-footer>
          <b-button variant="light" @click="closeDisplayModal">
            Cancelar
          </b-button>
          <b-button variant="primary" @click="solicitarReport" :disabled="detailReport < 0 || monthReport < 0">
            Generar
          </b-button>
        </template>
      </b-modal>

    <LoadingMask :active="loading"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ClientStatus, Workspace, ClientWorkspacesFilters, Domain, BLUEMESSAGING_ID, DomainType } from '@/types/Catalogs'
import DateSelector from '@/components/generic/DateSelector.vue'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import catalogsService from '@/services/CatalogsService'
import { PermissionNames, RoleNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import { PageRequest, PageResponse } from '@/types/Support'
import MessageService from '@/services/support/MessageService'
import reportsService from '@/services/ReportsService'
import { MessageError, MessageSuccess } from '@/components/generic/MessageHandling.vue'
import LogService, { ToString } from '@/services/support/LogService'
import { NUMBER } from '@/types/GeneralConstants'

@Component({
  components: {
    DateSelector,
    LoadingMask
  }
})
export default class AdminWorkspacesFromClients extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: ClientStatus.APROBACION })
  status: ClientStatus

  @Prop({ required: true, default: '' })
  title: number

  @Prop({ required: true, default: [] })
  domains: Domain[]

  @Prop({ required: false, default: [] })
  allWorkspaces: Workspace[]

  @Prop({ required: false, default: false })
  autoForm: boolean

  @Prop({ required: false, default: false })
  readOnly: number

  MAX_WORKSPACES_FOR_INDIVIDUAL_DOMAIN = 2
  PAGE_SIZE = 500
  formOpen = false
  domainSelectionOpen = false
  loading = false
  domainSelected: any = {}
  domainSelectedBackup: any = {}
  workspaces: Workspace[] = []
  workspaceSelected = new Workspace()
  workspacesStatus = [
    { value: 'active', text: 'Activo', disabled: true },
    { value: 'inactive', text: 'Baja', disabled: true },
    { value: 'suspended', text: 'Suspendido', disabled: true }
  ]
  domainSelectedWorkspaces: PageResponse<Workspace> = new PageResponse()
  domainsAndClients: Map<number, number[]> = new Map()
  availableDomainIds: number[] = []
  searchDomain = ''
  form = Workspace.getIntanceForEdit()

  regexPhone = /^[+]?[0-9]{10,15}$/

  detailReport: number = -1
  monthReport: number = -1

  /**
   * Gets the name of the month corresponding to the given index.
   * @param {number} monthIndex - Index of the month (0 for January, 11 for December).
   * @returns {string} Name of the month in Spanish.
   */
  getMonthName (monthIndex: number) {
    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]
    return monthNames[monthIndex]
  }

  /**
   * Gets the name of the current month.
   * @returns {string} Name of the current month in Spanish.
   */
  currentMonthName () {
    return this.getMonthName(new Date().getMonth())
  }

  /**
   * Gets the name of the previous month.
   * @returns {string} Name of the previous month in Spanish.
   */
  previousMonthName () {
    let currentMonth = new Date().getMonth()
    let previousMonth = currentMonth === 0 ? 11 : currentMonth - 1
    return this.getMonthName(previousMonth)
  }

  showDisplayModal () {
    this.$bvModal.show('report-support-billing')
  }

  closeDisplayModal () {
    this.detailReport = -1
    this.monthReport = -1
    this.$bvModal.hide('report-support-billing')
  }

  /**
   * Sending a request to the server to generate a report.
   */
  solicitarReport () {
    reportsService
      .postSupportBilling(
        this.detailReport,
        this.userEmail,
        this.id,
        this.workspaceSelected.domain.id,
        this.monthReport
      )
      .then((response) => {
        let message = `En los próximos 10 minutos recibirá un correo con el reporte, cualquier duda por favor comunícate a soporte.`
        let messageValues = {
          title: 'Generando reporte.',
          message: message
        }
        new MessageSuccess({ propsData: messageValues }).displaMessage()
      })
      .catch((error) => {
        let messageValues = {
          title: 'Surgio un error contacte a soporte',
          message: '',
          delay: 10000,
          error: error
        }
        new MessageError({ propsData: messageValues }).displayMessage()
      })
      .finally(() => {
        this.closeDisplayModal()
      })
  }

  mounted () {
    this.init()
    if (this.autoForm) {
      this.formOpen = true
    }
  }

  get getActions () {
    return [
      {
        name: 'Modificar',
        icon: 'fal fa-file-edit',
        onClick: this.updateItem,
        disabled: !this.workspaceSelected.id || !this.hasWorkspaceUpdatePermission,
        display: this.hasWorkspaceUpdatePermission
      },
      {
        name: 'Crear dominio',
        icon: 'fal fa-file-plus',
        onClick: this.onCreateDomain,
        display: this.hasDomainCreationPermission
      },
      {
        name: 'Relacionar dominio',
        icon: 'fal fa-file-import',
        onClick: this.newItem,
        disabled: this.formOpen || !this.hasWorkspaceCreationPermission,
        display: this.hasWorkspaceCreationPermission
      },
      {
        name: 'Detalle de facturación mensual',
        icon: 'fal fa-file-invoice-dollar',
        onClick: this.showDisplayModal,
        disabled: !this.workspaceSelected.id,
        display: this.hasBillingSupportRequestPermission
      }
    ]
  }

  get hasBillingSupportRequestPermission () {
    return userInfoStore.hasPermission(PermissionNames.BILLING_SUPPORT_REPORT_REQUEST)
  }

  get hasDomainCreationPermission () {
    return userInfoStore.hasPermission(PermissionNames.DOMAINS_CREATE)
  }

  get hasWorkspaceCreationPermission () {
    return userInfoStore.hasPermission(PermissionNames.WORKSPACES_CREATE)
  }

  get hasWorkspaceUpdatePermission () {
    return userInfoStore.hasPermission(PermissionNames.WORKSPACES_UPDATE)
  }

  get hasFinanceAdminRole () {
    return userInfoStore.hasRole(RoleNames.FINANCES_ADMIN)
  }

  get isClientActive () {
    return this.status === ClientStatus.ACTIVO
  }

  /**
   * Returns the email property of the userInfo object.
   */
  get userEmail () {
    return userInfoStore.userInfo.email
  }

  init () {
    this.workspaces = []
    const pageRequest = new PageRequest<ClientWorkspacesFilters>(this.PAGE_SIZE)
    pageRequest.filters.clientId = this.id
    this.loadWorkspacesPage(pageRequest)
      .then(() => {
        this.domainsAndClients = this.createDomainAndClientMap(this.allWorkspaces)
        this.loadAvailableDomains()
      })
  }

  newItem () {
    this.workspaceSelected = Workspace.getIntanceForEdit()
    this.form = this.workspaceSelected
    this.searchDomain = ''
    this.showForm(true)
    setTimeout(() => {
      document.getElementById('input-domain')!.focus()
    }, 500)
  }

  updateItem () {
    this.form = JSON.parse(JSON.stringify(this.workspaceSelected))
    const domain = this.domains.find((it: Domain) => it.id === this.workspaceSelected.domain.id) as any
    this.selectDomain(domain)
    this.showForm(true)
  }

  showForm (flag: boolean) {
    if (flag) {
      this.domainSelectedBackup = {}
      this.formOpen = true
    } else {
      this.formOpen = false
    }
  }

  showDomainSelection (flag: boolean) {
    if (flag) {
      this.searchDomain = ''
      this.domainSelected = {}
      this.domainSelectionOpen = true
    } else {
      setTimeout(() => {
        this.domainSelectionOpen = false
        if (this.domainSelectedBackup.code) {
          this.selectDomain(this.domainSelectedBackup)
        }
      }, 200)
    }
  }

  async loadWorkspacesPage (pageRequest: PageRequest<any>) {
    await catalogsService.getWorkspacesByClient(pageRequest).then(response => {
      this.workspaces.push(...response.results)

      if (this.workspaces.length < response.total) {
        pageRequest.page++
        this.loadWorkspacesPage(pageRequest)
      } else {
        this.$emit('workspacesLoaded', this.workspaces)
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de Workspaces: ${ToString(error.response ?? error)}`)
    })
  }

  /**
   * Based on a list of workspaces create a Map with the form:
   * : Key - domainId
   * : Value - [clientIds]; this are all the clients related to a domain
   * @returns a Map with the info of each domain; type and clients
   */
  createDomainAndClientMap (workspaces: Workspace[]): Map<number, number[]> {
    const map = new Map<number, number[]>()
    workspaces.forEach(workspace => {
      let currentDomainId = workspace.domain.id
      let currentClientId = workspace.client.id
      if (map.has(currentDomainId)) {
        map.get(currentDomainId)!.push(currentClientId)
      } else {
        map.set(currentDomainId, [currentClientId])
      }
    })
    return map
  }

  /**
   * Set which domains would be able to select
   */
  async loadAvailableDomains () {
    this.domainsAndClients.forEach((clientIds, domainId) => {
      let domain = this.domains.find(domain => domain.id === domainId)
      // We add all the Ecosystm domains
      if (domain && domain.domainType === DomainType.ECOSYSTEM) {
        this.availableDomainIds.push(domain!.id)
      } else { // Otherwise is an Individual domain
        if (clientIds.length < this.MAX_WORKSPACES_FOR_INDIVIDUAL_DOMAIN) { // It has zero or one client
          if (clientIds.length === 0) {
            this.availableDomainIds.push(domain!.id)
          } else if ((clientIds.includes(BLUEMESSAGING_ID) && this.id !== BLUEMESSAGING_ID) ||
          (!clientIds.includes(BLUEMESSAGING_ID) && this.id === BLUEMESSAGING_ID)) {
            this.availableDomainIds.push(domain!.id)
          }
        }
      }
    })
    // Add all the domains that don't have workspaces
    this.domains.forEach(domain => {
      if (!this.domainsAndClients.has(domain.id)) this.availableDomainIds.push(domain.id)
    })
    // Delete items duplicated
    this.availableDomainIds = Array.from(new Set<number>(this.availableDomainIds))
  }

  /**
   * Validate which domain can be selected
   *
   * @param domain to validate
   */
  isMatchDomain (domain: Domain) {
    if (this.workspaces.length) {
      // Hide all domains that are already related to the client
      for (let workspace of this.workspaces) {
        if (workspace.domain.id === domain.id) return false
      }
    }
    // Hide all domains that can be selected
    if (!this.availableDomainIds.includes(domain.id)) return false

    if (!this.searchDomain) return true

    // Match the client name
    const regexSearch = new RegExp(this.searchDomain, 'i')
    return regexSearch.test(domain.name)
  }

  async selectDomain (domain: Domain) {
    this.domainSelected = domain
    this.domainSelectedBackup = domain
    this.searchDomain = domain.name
    this.domainSelectedWorkspaces = await this.firstTenWorkspacesByDomain(domain.id)
  }

  getWorkspaceStatusDescription (status: string) {
    return Workspace.getStatusDescription(status)
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  async firstTenWorkspacesByDomain (domainId: number): Promise<PageResponse<Workspace>> {
    const request = new PageRequest<ClientWorkspacesFilters>()
    request.size = 10
    request.filters.domainId = domainId
    const response = await catalogsService.getWorkspacesByDomain(request)
    return response
  }

  async onSubmit () {
    if (!this.domainSelected.id) {
      MessageService.error('Validación de formulario', 'Debe elegir un dominio', 3000)
      return
    }
    this.form.client.id = this.id
    this.form.domain.id = this.domainSelected.id

    const requiredFieldsFillUp = await this.$validator.validateAll()
    if (requiredFieldsFillUp) {
      this.loading = true

      // If this workspaces created is the first for the domain, we set it as owner
      if (this.domainSelectedWorkspaces.total === NUMBER.ZERO) {
        // Exception when Bluemessaging will be the owner
        if (!this.hasFinanceAdminRole && this.form.client.id === BLUEMESSAGING_ID) {
          this.$bvToast.toast(
            'Lo sentimos, no puede asociar a Bluemessaging como owner del dominio. Por favor, seleccione un dominio diferente o contacte al Gerente de Fiananzas.',
            {
              title: 'Asignación no autorizada.',
              variant: 'danger',
              autoHideDelay: 6000
            }
          )
          this.loading = false
          return
        }
        this.form.owner = true
      }

      catalogsService.saveWorkspace(this.form).then((response: Workspace) => {
        this.init()
        this.showForm(false)
        this.$emit('update-status', ClientStatus.ACTIVO)
        if (this.autoForm) {
          this.$emit('close')
        }
        this.$bvToast.toast(
          'El Workspace se agregado correctamente.',
          {
            title: 'Workspace completado.',
            variant: 'success',
            autoHideDelay: 6000
          }
        )
      }).catch((error) => {
        new MessageError({
          propsData: {
            title: 'Error al guardar.',
            message: '',
            delay: 10000,
            error: error } }).displayMessage()
      }).finally(() => {
        this.loading = false
      })
    }
  }

  onCreateDomain () {
    this.$emit('create-domain')
  }

  onCancel () {
    this.$emit('close')
  }
}
</script>

<style scoped lang="scss">
.form-area.collapsed {
  width: calc(50% - 10px) !important;
}
.workspace-form-modal {
  background-color: #fff;
  z-index: 2;
  padding: 75px 20px 20px 20px;
  border-left: 1px solid #dfdfdf;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  min-width: 450px;
  width: 50%;
  overflow-y: auto;
}
.workspaces-table tr {
  cursor: pointer;
}
.workspaces-table tr th {
  font-size: 0.9rem;
}
.workspaces-table tr.selected {
  background-color: var(--primary-color);
  color: #fff;
}

.workspace-actions {
  margin: 24px 10px 0 32px;
  width: fit-content;
  padding: 8px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 5px 2px #ddd;

  .col {
    padding: 0;
  }

  .workspace-action {
    height: 48px;
    border-right: 1px solid #ddd;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 300;
    i {
      margin: 0 3px;
      font-size: 1.1rem;
    }
    &:hover, &.active {
      background-color: #f0f0f0;
    }
    &.disabled {
      opacity: 0.35;
      pointer-events: none;
    }
  }
}
</style>
